import Vue from 'vue'
import _ from 'lodash';
import router from 'vue-router'
import Home from './pages/Home.vue'
import RouteInfo from './pages/RouteInfo.vue'
import UserData from './pages/UserData.vue'
import MainMap from './pages/MainMap.vue'
import FavoriteList from './pages/FavoriteList.vue'
import Certify from './pages/Certify.vue'
import Contact from './pages/Contact.vue'
import CreateHike from './pages/CreateHike.vue'
import OwnHikes from './pages/OwnHikes.vue'
import Info from './pages/Info.vue'
import DisplayCertify from './pages/DisplayCertify.vue'
import Intro from './pages/Intro.vue'
import EntryForm from './pages/EntryForm.vue'
import MyEntries from './pages/MyEntries.vue'
import PaymentAdmin from './pages/PaymentAdmin.vue'
import CertifyList from './pages/CertifyList.vue'
import Login from './pages/Login.vue'
import Routes from './pages/Routes.vue'
import GYIK from './pages/GYIK.vue'
import Promotions from './pages/Promotions.vue'
import Moderator from './pages/Moderator.vue'

Vue.use(router)


export default new router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/promotions',
      name: 'promotions',
      component: Promotions
    },
    {
      path: '/moderator',
      name: 'moderator',
      component: Moderator
    },
    {
      path: '/gyik',
      name: 'gyik',
      component: GYIK
    },
    {
      path: '/certifylist',
      name: 'certifylist',
      component: CertifyList
    },
    {
      path: '/paymentadmin',
      name: 'paymentadmmin',
      component: PaymentAdmin
    },
    {
      path: '/myentries',
      name: 'myentries',
      component: MyEntries,
      props: true
    },
    {
      path: '/entryform',
      name: 'entryform',
      component: EntryForm,
      props: true
    },
    {
      path: '/login/:id',
      name: 'login',
      component: Login
    }, 
    {
      path: '/routes',
      name: 'routes',
      component: Routes
    },     
    {
      path: '/',
      name: 'home',
      component: Home
    },     
    {
      path: '/intro',
      name: 'intro',
      component: Intro
    },     
    {
      path: '/userdata',
      name: 'userdata',
      component: UserData
    }, 
    {
      path: '/routeinfo/:routeId',
      name: 'routeinfo',
      component: RouteInfo
    },            
    {
      path: '/createhike',
      name: 'createhike',
      component: CreateHike
    },  
    {
      path: '/ownhikes',
      name: 'ownhikes',
      component: OwnHikes
    },        
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },  
    {
      path: '/info',
      name: 'info',
      component: Info
    },      
    {
      path:'/displaycertify/:cert',
      name:'displaycertify',
      component: DisplayCertify,
    },                
    {
      path:'/mainmap',
      name:'mainmap',
      component: MainMap,
      props: true
    },        
    {
      path:'/favoritelist',
      name:'favoritelist',
      component: FavoriteList
    }, 
    {
      path:'/certify',
      name:'certify',
      component: Certify
    }, 
  ],
  

})
